module.exports = __webpack_public_path__ + "static/media/arrow.728306a7.svg";